export default __webpack_public_path__ + "d045a5d196a5cbb883d2a3a0d69f5c3f.ttf";